module.exports = __webpack_public_path__ + "img/trophy.70fcdb85.svg";